<template>
  <v-card>
    <v-card-title>
      <h5 class='title' >{{title}}</h5>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-card-text>
      <v-data-table
      :rows-per-page-items="[10,25,50]"
      :loading='loading' :headers="headers" :items="data" :search='search'
      v-model="selected" :select-all='selectable' full-width dense
      item-key="id" class="elevation-1" >
        <template slot="items" slot-scope="props">
          <tr >
            <td v-if='selectable' >
              <v-checkbox :input-value="props.selected"
                v-model='props.selected' primary hide-details >
              </v-checkbox>
            </td>
            <td v-for='header in headers' :key='header.value' >{{ props.item[header.value] }}</td>
            <td>
              <v-menu bottom left>
                <v-btn slot="activator" icon >
                  <v-icon>more_vert</v-icon>
                </v-btn>

                <v-list dense>
                  <v-list-tile
                    v-for="action in actions" :key="action.icon"
                    @click='$emit(action.action, props.item)' >
                    <v-list-tile-title>
                      <v-icon>{{action.icon}}</v-icon>
                      {{ action.text }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'InvoiceTable',
  props: {
    title: { type: String },
    loading: { type: Boolean, default: false },
    selectable: { type: Boolean, default: false },
    data: { type: Array, default: () => { return [] } },
    headers: { type: Array, default: () => { return [] } },
    actions: { type: Array, default: () => { return [] } }
  },
  data () {
    return {
      selected: [],
      search: ''
    }
  }
}
</script>

<style>
/* table th {
   position: sticky;
   position: --webkit-sticky;
   top:90px;
} */
</style>



// WEBPACK FOOTER //
// Table.vue?7b43eda1